<template>
  <div>
    <el-drawer
      v-if="visible"
      :visible="visible"
      :title="$l('form_label_cart') || '购物车'"
      direction="rtl"
      :size="899"
      @close="close()"
    >
      <div class="drawer-main">
        <Main ref="main" @close="close()" />
      </div>
      <div class="d-flex justify-content-end mt-2 mb-2 mr-2">
        <el-button type="success" size="small" @click="commit()">
          {{ $l('table_label_commit') || '提交需求' }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    commit() {
      const tmpData = this.$refs.main.getFormData()
      if (tmpData) {
        this.$api.resFabricDemandCommitApi({ ...tmpData }).then(() => {
          this.$emit('reset')
          this.$emit('close')
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.drawer-main {
  padding: 0 20px 32px;
}
</style>
